import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

export default function SplashScreen() {
  const [visible, setVisible] = useState(() => !sessionStorage.getItem('gtc_splash_shown'));

  useEffect(() => {
    if (!visible) return;
    sessionStorage.setItem('gtc_splash_shown', '1');
    const t = setTimeout(() => setVisible(false), 1900);
    return () => clearTimeout(t);
  }, [visible]);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          key="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.6, ease: 'easeOut' }}
          className="fixed inset-0 z-[999] flex items-center justify-center bg-[var(--bg-void)] overflow-hidden"
          data-testid="splash-screen"
        >
          {/* Radial gold glow background */}
          <motion.div
            initial={{ opacity: 0, scale: 0.6 }}
            animate={{ opacity: 0.6, scale: 1.2 }}
            transition={{ duration: 1.4, ease: 'easeOut' }}
            className="absolute inset-0 pointer-events-none"
            style={{
              background: 'radial-gradient(circle at center, rgba(212,175,55,0.18) 0%, transparent 60%)',
            }}
          />

          {/* Concentric rings */}
          {[0, 1, 2].map((i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0.6 }}
              animate={{ opacity: [0, 0.5, 0], scale: [0.6, 1.8, 2.6] }}
              transition={{ duration: 2.1, delay: i * 0.25, ease: 'easeOut', repeat: 0 }}
              className="absolute w-40 h-40 rounded-full border border-[var(--gold)]/40 pointer-events-none"
            />
          ))}

          {/* Logo */}
          <motion.div
            initial={{ opacity: 0, scale: 0.7, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            transition={{ duration: 0.7, delay: 0.15, ease: [0.2, 0.9, 0.3, 1.2] }}
            className="relative flex flex-col items-center"
          >
            <div
              className="w-32 h-32 rounded-3xl overflow-hidden"
              style={{ boxShadow: '0 0 60px rgba(212,175,55,0.35), inset 0 0 20px rgba(212,175,55,0.1)' }}
            >
              <img src="/logo.png" alt="Golden TV Connect" className="w-full h-full object-contain" />
            </div>

            <motion.div
              initial={{ opacity: 0, y: 10 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: 0.7 }}
              className="mt-6 text-center"
            >
              <div className="font-heading text-2xl font-light tracking-tight text-white">
                Golden <span className="text-[var(--gold)] font-medium">TV</span>
              </div>
              <div className="text-[10px] uppercase tracking-[0.4em] text-white/50 mt-1">Connect</div>
            </motion.div>

            {/* Loading bar */}
            <motion.div
              initial={{ scaleX: 0, opacity: 0 }}
              animate={{ scaleX: 1, opacity: 1 }}
              transition={{ duration: 1.2, delay: 0.5, ease: 'easeInOut' }}
              className="mt-6 h-0.5 w-32 origin-left bg-gradient-to-r from-transparent via-[var(--gold)] to-transparent"
            />
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
